import type { ReactNode, JSX} from "react";
import { cn } from "./cn";
import { Icon } from "./Icon";

export interface AgentChatComposerProps {
  /** Input placeholder text */
  readonly placeholder: string;
  /** Optional leading action (e.g. attach button) */
  readonly leadingAction?: ReactNode;
  /** Extra className */
  readonly className?: string;
}

/**
 * A chat input bar with optional attach button and send button.
 * Used in agent module conversations.
 */
export function AgentChatComposer({
  placeholder,
  leadingAction,
  className,
}: AgentChatComposerProps): JSX.Element {
  return (
    <div className={cn("border-t border-edge px-4 py-3 flex items-center gap-3", className)}>
      {leadingAction}
      <input
        className="flex-1 h-10 bg-surface-hover border border-edge rounded-[10px] px-3.5 text-sm text-content placeholder:text-content-tertiary"
        placeholder={placeholder}
        aria-label={placeholder}
      />
      <button
        className="w-9 h-9 rounded-full border-none bg-accent text-white cursor-pointer inline-flex items-center justify-center"
        type="button"
      >
        <Icon name="send" size={15} />
      </button>
    </div>
  );
}
